import { type SortByKeys, SORT_BY_KEYS } from '@/constants/search'
import { type SelectItem } from '@/ui/molecules/select'

/** Verifies if the sorting dropdown option is a valid one */
export const isSortByDropdownValueValid = (value: SelectItem['value']): value is SortByKeys =>
  Object.values(SORT_BY_KEYS).includes(value as SortByKeys)
